const MONTHS_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
const MONTHS_LONG = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

// Las fechas llegan como ISO; se muestran en hora de la Ciudad de México para no cambiar de día.
function ymd(value) {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString('en-CA', { timeZone: 'America/Mexico_City' }).split('-').map(Number)
}

export function formatShortDate(value) {
  const p = ymd(value)
  return p ? `${p[2]} ${MONTHS_SHORT[p[1] - 1]} ${p[0]}` : '—'
}

export function formatLongDate(value) {
  const p = ymd(value)
  return p ? `${p[2]} de ${MONTHS_LONG[p[1] - 1]} de ${p[0]}` : '—'
}

export function formatMoney(value, decimals = false) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return n.toLocaleString('es-MX', { minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: 2 })
}

export const METHOD_LABEL = { TRANSFER: 'Transferencia', CARD: 'Tarjeta', CASH: 'Efectivo', OTHER: 'Otro' }

export const TAX_REGIMES = [
  '601 · General de Ley Personas Morales',
  '603 · Personas Morales con Fines no Lucrativos',
  '612 · Personas Físicas con Actividades Empresariales y Profesionales',
  '621 · Incorporación Fiscal',
  '626 · Régimen Simplificado de Confianza',
]

export const isValidRfc = (v) => /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(String(v || '').trim().toUpperCase())
export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim())

export const ERROR_MESSAGES = {
  PLAN_TOO_SMALL_PLOTS: 'Tu parque tiene más naves de las que permite ese plan. Elige uno con más capacidad.',
  PLAN_TOO_SMALL_USERS: 'Tu parque tiene más usuarios de los que permite ese plan. Elige uno con más capacidad.',
  PLAN_NOT_FOUND: 'Ese plan ya no está disponible. Actualiza la página e intenta de nuevo.',
  SAME_PLAN: 'Ya tienes ese plan contratado.',
  NOT_ALLOWED_WHILE_IMPERSONATING: 'No se puede hacer mientras ves el parque como superadmin.',
  FORBIDDEN: 'Solo el administrador del parque puede hacer esto.',
  INVALID_RFC: 'El RFC no es válido.',
  INVALID_ZIP: 'El código postal debe tener 5 dígitos.',
  INVALID_EMAIL: 'El correo no es válido.',
}

export const errorText = (err, fallback = 'No se pudo completar la acción. Intenta de nuevo.') => ERROR_MESSAGES[err?.code] || fallback